export const SET_USER = 'AUTH/SET_USER';
export const LOGOUT = 'AUTH/LOGOUT';
